export default __webpack_public_path__ + "static/media/speaker.0f8d661c.svg";